import { graphql, useStaticQuery } from "gatsby"

const useContactInfo = () => {
  const data = useStaticQuery(graphql`
    {
      allContentfulContactInfo(sort: { order: ASC }) {
        nodes {
          name
          email
          address
          englishAddress
          phoneNumber
          pathOfNavigation {
            pathOfNavigation
          }
          googleMapUrl {
            googleMapUrl
          }
          caseNumber
        }
      }
    }
  `)
  const contactData = data.allContentfulContactInfo.nodes
  const contactInfo = contactData.reduce((prev, { name, ...data }) => {
    prev[name] = data
    return prev
  }, {})
  const officesInfo = contactData.map(({ name }) => name)
  return { contactData, contactInfo, officesInfo }
}

export default useContactInfo
